export default {
  active: "Ativar",
  add: "Adicionar",
  cancel: "Cancelar",
  clear: "Limpar",
  continue: "Continuar",
  delete: "Deletar",
  disable: "Desativar",
  filters: "Filtros",
  filter: "Filtro",
  finalize: "Finalizar",
  return: "Voltar",
  save: "Salvar",
  search: "Pesquisar",
  submit: "Enviar",
  to_enter: "Entrar",
  verify: "Verificar",
  change_binds: "Alterar vínculos",
  fast_config: "Configuração expressa",
  find: "Buscar",
  find_again: "Buscar novamente",
  select: "Selecionar",
  list_occupations: "Listar ocupações",
  create_protocol: "Criar protocolo",
  remove: "Remover",
  bind_procedure: "Vincular procedimento",
  bind: "Vincular",
  close: "Fechar",
  confirm: "Confirmar",
  select_all: "Selecionar todos",
  uncheck_all: "Desmarcar todos",
  add_occupation: "Adicionar ocupação",
  schedule_rules: "Regras da agenda",
  duplicate: "Duplicar",
  today: "Hoje",
  visualization: "Visualização",
  update_schedule: "Editar agenda",
  advance: "Avançar",
  add_attachament: "Adicionar anexo",
  click_here: "Clique aqui",
  drag_and_drop_attachment:
    "ou arraste e solte o arquivo para realizar o upload",
  manually: "Preencher manualmente",
  data_sus: "Buscar no DataSUS",
  search_patient_in_dataSUS: "Buscar paciente no DataSUS",
  update: "Editar",
  options: "Opções",
  ok_understand: "Ok, entendi",
  block: "Bloquear",
  reactivate: "Reativar",
  back_to_unities: "Voltar para unidades",
  change_unity: "Alterar unidade",
  remove_unity_profile: "Remover unidade/perfil",
  add_unity_profile: "Adicionar unidade/perfil",
  try_again: "Tentar novamente",
  change_unity_profile: "Alterar unidade/perfil",
  disconnect: "Desconectar",
  yes: "Sim",
  no: "Não",
  reset_password: "Redefinir senha",
  add_attachment: "Adicionar anexo",
  add_patient: "Adicionar paciente",
  remove_permanently: "Remover item permanentemente",
  yes_confirm: "Sim, confirmar",
  add_procedure: "Adicionar procedimento",
  add_solicitations: "Adicionar solicitações",
  cancel_and_return: "Cancelar e voltar",
  remove_reference: "Remover referência",
  add_reference: "Adicionar referência",
  add_bind: "Adicionar vinculo",
  remove_bind: "Remover vinculo",
  view_report: "Visualizar relatório",
};
